export function isEmptyObject(obj: any): boolean {
    if (obj && Object.values(obj).every(item => !item)) {
        return true;
    }
    return false;
}